@use "../../styles/breakpoint.module.scss" as *;

.rootDarkText {
    composes: light from "../../styles/theming.module.css";
}

.rootLightText {
    composes: dark from "../../styles/theming.module.css";
}

.gradient {
    background: var(--xcient-gradient);
}

.content {
    --padding: var(--spacer-48);

    padding-block: var(--padding);
}

.media {
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            var(--rotate),
            rgb(var(--black-base) / 0%) 0%,
            rgb(var(--black-base) / 0%) 68.75%,
            rgb(var(--black-base) / 100%) 100%
        );
    }
}

.overlayOff {
    visibility: visible;
}

.overlayBottom {
    --rotate: 180deg;

    composes: media;
}

.overlayTop {
    --rotate: 0deg;

    composes: media;
}

.overlayTopBottom {
    --rotate: 0deg;

    composes: media;

    &::after {
        background: linear-gradient(
            var(--rotate),
            rgb(var(--black-base) / 100%) 0%,
            rgb(var(--black-base) / 0%) 31.25%,
            rgb(var(--black-base) / 0%) 68.75%,
            rgb(var(--black-base) / 100%) 100%
        );
    }
}

.overlayCover {
    composes: media;

    &::after {
        background: rgb(var(--black-base) / 55%);
    }
}
